import React from "react";
import { Tooltip, Button, Backdrop } from "@mui/material";

const TutorialTooltip = ({
  children,
  config,
  activeTutorialId,
  completeTutorial,
  onPrimaryBtnClick,
}) => {
  const { id, title, content, secondaryBtnLabel, primaryBtnLabel } =
    config ?? {};
  const isActive = activeTutorialId === id;

  return (
    <Tooltip
      open={isActive}
      placement="top"
      title={
        <div className="tutorial-tooltip">
          <h4>{title}</h4>
          {typeof content === "string" ||
          (React.isValidElement(content) && content.type === React.Fragment) ? (
            <p className="default-tooltip-text">{content}</p>
          ) : (
            content
          )}
          <div className="tutorial-tooltip-btn-container">
            {secondaryBtnLabel && (
              <Button
                className="tutorial-tooltip-secondary-btn"
                onClick={completeTutorial}
              >
                {secondaryBtnLabel}
              </Button>
            )}
            {primaryBtnLabel && (
              <Button
                className="tutorial-tooltip-primary-btn"
                onClick={onPrimaryBtnClick ?? completeTutorial}
              >
                {primaryBtnLabel}
              </Button>
            )}
          </div>
        </div>
      }
      slotProps={{
        popper: {
          // allows the tooltip to be seen in fullscreen mode
          disablePortal: true,
          sx: {
            "& .MuiTooltip-tooltip": {
              backgroundColor: "white",
              border: "1px solid #208347",
              borderRadius: "12px",
              /* M3/Elevation Light/3 */
              boxShadow:
                "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)",
              padding: "12px 16px 8px 16px",

              "> .MuiTooltip-arrow": {
                color: "white",
                fontSize: "30px",
                // add 1px to bottom to prevent 1px space between arrow and tooltip content
                // in certain window sizes
                position: "absolute",
                bottom: "1px",
                "&:before": {
                  border: "1px solid #208347",
                },
              },
            },
          },
          modifiers: [
            {
              name: "preventOverflow",
              enabled: true,
              options: {
                tether: false,
              },
            },
          ],
        },
      }}
      arrow
    >
      <div>
        <div
          className={
            isActive
              ? "tutorial-tooltip-active-highlight"
              : "tutorial-tooltip-non-active-highlight"
          }
        >
          {children}
        </div>
        {/* backdrop needs to be placed here to allow highlighted tool to be shown above it */}
        <Backdrop open={isActive} id="tutorial-tooltip-overlay" />
      </div>
    </Tooltip>
  );
};

export default TutorialTooltip;
